
export default {
  'm':{
    'sms_login':'เข้าสู่ระบบด้วยข้อความสั้น',
    'get_vercode':'ส่ง',
    'change_mobile':'เปลี่ยนเบอร์โทร',
    'log_reg_agree':'เข้าสู่ระบบ/ลงทะเบียน หมายถึง ยอมรับ {msg_ss}',
    'old_mobile':'เบอร์โทรเดิม',
    'new_mobile':'เบอร์โทรใหม่',
    'agency_reginfo_fill':'กรอกข้อมูลการลงทะเบียนกิลด์',
    'audit_res':'ผลการตรวจสอบ',
    'agency_name':'ชื่อกิลด์',
    'agency_name_input':'กรุณากรอกชื่อกิลด์',
    'agency_name_input_note':'หมายเหตุ : ชื่อกิลด์แนะนำสั้น จำง่าย ไม่เกิน 30 คำ',
    'agency_logo':'โลโก้กิลด์',
    'agency_logo_unpload_note':'โปรดอัปโหลดโลโก้กิลด์ที่ชัดเจนในรูปแบบ PNG/JPG/JPEG',
    'agency_contact_name':'ผู้ติดต่อกิลด์',
    'user_contact_name':'กรุณากรอกชื่อบุคคลที่ติดต่อกับแพลตฟอร์มผู้ใช้ทุกวัน',
    'agency_contact_phone':'เบอร์โทรติดต่อกิลด์',
    'agency_whatsapp':'หัวหน้ากิลด์ WhatsApp',
    'agency_whatsapp_contact':'โปรดป้อนข้อมูลติดต่อ WhatsApp ของหัวหน้ากิลด์',
    'agency_use_lang':'ภาษาที่หัวหน้ากิลด์ใช้',
    'agency_head_ID':'ID หัวหน้ากิลด์',
    'agency_ID_input':'โปรดป้อน ID ผู้ใช้ของหัวหน้ากิลด์ BuzzCast APP เพื่อแจกจ่ายกองทุนในภายหลัง',
    'reg_country':'ประเทศที่ลงทะเบียน',
    'inhand_ID_photo':'บัตรประจำตัวที่มีรูปถ่ายอยู่ในมือ',
    'upload_note_t':'ข้อควรพิจารณาในการอัปโหลด',
    'agency_self_inhand_ID':'ตัวแทนจะต้องดำเนินการด้วยตนเองพร้อมเอกสารหนังสือเดินทาง',
    'photo_must_clearly':'ด้านหน้าต้องแสดงตัวบุคคลและข้อมูลหนังสือเดินทางจริงอย่างชัดเจนด้วยการถ่ายภาพ',
    'mian_form_country':'ประเทศต้นทางหลักของโฮสต์',
    'invite_code':'รหัสการเชิญ',
    'your_profile_submit_success':'ส่งเอกสารของคุณเรียบร้อยแล้ว! เราจะจัดการกับมันโดยเร็วที่สุด<br>ผลการตรวจสอบจะถูกส่งไปยังการแจ้งเตือนของหัวหน้ากิลด์ใน BuzzCast APP และโปรดใส่ใจตรวจสอบ!',
    'your_profile_approved':'เอกสารที่คุณส่งมาไม่ผ่านการพิจารณา เหตุผลในการปฏิเสธคือรูปถ่ายหนังสือเดินทางที่ถืออยู่ไม่ชัดเจน"<br>กรุณากรอกใหม่หรือติดต่อผู้ช่วยอย่างเป็นทางการใน BuzzCastAPP เพื่อขอคำปรึกษา',
    'return_refill':'กลับมากรอกใหม่อีกครั้ง',
    'success_agency':'ขอแสดงความยินดีที่คุณติดตั้งแพลตฟอร์มสำเร็จ [คลิกฉัน] เพื่อเริ่มทำงาน!',
    'personal_account':'บัญชีส่วนตัว',
    'my_agency':'กิลด์ของฉัน',
    'your_agency_been_forcibly':'กิลด์ของคุณถูกบังคับยุติโดยแพลตฟอร์ม และคุณจะไม่สามารถเข้าสู่ระบบได้อีกต่อไป. หากคุณมีคำถามใด ๆ โปรดติดต่อผู้ช่วยอย่างเป็นทางการของ BuzzCastAPP หรือการดำเนินการพิเศษ',
    'invite_live_join':'เชิญเจ้าภาพเข้าร่วมกิลด์ลิงค์',
    'base_info':'ข้อมูลพื้นฐาน',
    'apply_time':'วันรับสมัคร',
    'join_time':'เข้าร่วมเวลา',
    'cooper_status':'สถานะความร่วมมือ',
    'streamer_manage':'การบริหารโฮสต์',
    'sereamer_apply':'อนุมัติโฮสต์',
    'sereamer_nickname':'ชื่อเล่นโฮสต์',
    'remark':'ข้อสังเกต',
    'no_remark':'ไม่มีข้อสังเกต',
    'add_remark':'เพิ่มข้อสังเกต',
    'birth':'วันเกิด',
    'user_status':'สถานะผู้ใช้',
    'temporarily_frozen':'แช่แข็งชั่วคราว',
    'permanently_frozen':'ถูกแช่แข็งตลอดกาล',
    'fans_num':'จำนวนผู้ติดตาม',
    'sign_status':'สถานะสัญญา',
    'sign_ing':'ภายใต้สัญญา',
    'sign_time':'วันที่ทำสัญญา',
    'release_time':'วันที่ยกเลิก',
    'live_viola_record':'บันทึกการละเมิดการถ่ายทอดสด',
    'sign_record':'บันทึกสัญญา',
    'current_contract_status':'สถานะสัญญาปัจจุบัน',
    'termination_reason':'เหตุผลในการยุติ',
    'violation_reason':'สาเหตุของการละเมิด',
    'violation_time':'วันที่ฝ่าฝืน',
    'processing_result':'ผลลัพธ์ของกระบวนการ',
    'exported_data':'ส่งออกข้อมูล',
    'join_agency_apply':'อนุมัติเข้ากิลด์',
    'audit_status':'สถานะการอนุมัติ',
    'pending_review':'อยู่ระหว่างการพิจารณา',
    'pending_HQ_review':'กำลังรอการตรวจสอบสำนักงานใหญ่',
    'not_approved_HQ':'การตรวจสอบสำนักงานใหญ่ล้มเหลว',
    'withdrawn':'เพิกถอน',
    'audit_trail':'ตรวจสอบบันทึก',
    'oper':'ปฏิบัติการ',
    'other_video_materials':'เอกสารวิดีโออื่นๆ',
    'pass':'ผ่าน',
    'pass_streamer_join_agency_apply':'ผ่านการสมัครโฮสต์เพื่อเข้าร่วมกิลด์',
    'reject_streamer_join_agency_apply':'ปฎิเสธการสมัครเจ้าบ้านเข้ากิลด์',
    'agree_streamer_join_agency':'เห็นด้วยกับสมอ {msg_ss1} ที่จะเป็นผู้ส่งที่ต่ำกว่า {msg_ss2}~',
    'reject_streamer_join_agency':'การสมัครเป็นสมาชิก {msg_ss1} ของสมาชิก {msg_ss2} ถูกปฏิเสธ!',
    'img_material':'เอกสารรูปภาพ',
    'approver':'ผู้อนุมัติ',
    'user_enter_bind_phone':'กรุณาป้อนเข้าหมายเลขโทรศัพท์',
    'vericode':'รหัสยืนยัน',
    'input_vericode':'โปรดใส่รหัสยืนยัน',
    'login':'เข้าสู่ระบบ',
    'reg':'เข้าสู่ระบบ',
    'logout':'เลิกทำ',
    'search_for':'ค้นหา',
    'subscription_closed':'ยกเลิกสัญญา',
    'agency_ID':'รหัสกิลด์: {msg_ss}',
    'reset':'รีเซ็ต',
    'live_ID':'ผู้ไลฟ์สด ID',
    'live_record':'บันทึกหน้าจอถ่ายทอดสด',
    'email':'อีเมล',
    'phone':'หมายเลขโทรศัพท์มือถือ',
    'mastery_lang':'ภาษาหลัก',
    'to':'ไปยัง',
    'cancel':'ยกเลิก',
    'Confirm':'กำหนด',
    'preview':'ดูตัวอย่าง',
    'rejected':'ถูกปฏิเสธ',
    'tip':'เตือน',
    'i_got_it':'ฉันเข้าใจแล้ว',
    'cancelled':'ยกเลิก',
    'refused':'ปฏิเสธ',
    'agency_agree':'กิลด์ได้ตกลง',
    'platform_agree':'แพลตฟอร์มตกลง',
    'user_not_exist':'ไม่มีผู้ใช้นี้ในระบบ',
    'user_frozen':'ผู้ใช้ถูกตรึง',
    'reviewing':'ในการตรวจสอบ',
    'review_pass':'รีวิวผ่าน',
    'review_failed':'การตรวจสอบล้มเหลว',
    'xx_hours':'{msg_ss} ชั่วโมง',
    'xx_days':'{msg_ss} วัน',
    'xx_hour': '{msg_ss} ชั่วโมง',
    'xx_day': '{msg_ss} วัน',
    'xx_year': '{msg_ss} ปี',
    'xx_years': '{msg_ss} ปี',
    'check_phone_istrue':'โปรดตรวจสอบหมายเลขโทรศัพท์ว่าป้อนถูกต้องหรือไม่',
    'male':'ชาย',
    'female':'หญิง',
    'avatar':'ภาพเหมือน',
    'normal':'ปกติ',
    'live_room':'ห้องไลฟ์',
    'view':'ดู',
    'oper_success':'การดำเนินการสำเร็จ',
    'copy_success':'คัดลอกสำเร็จ',
    'new_mobile_already_reg':'ลงทะเบียนหมายเลขโทรศัพท์มือถือใหม่แล้ว',
    'general_user':'ผู้ใช้ทั่วไป',

    'copy':'คัดลอก',
    'gender':'เพศ',
    'submit':'เสนอ',
    'permanent':'ถาวร',
    'agree_agreement':'ตกลงและปฏิบัติตามสัญญา',
    'vericode_error':'รหัสยืนยันไม่ถูกต้อง',
    'resend':'ส่งใหม่อีกครั้ง',
    'approved':'ผ่าน',
    'not_approved':'ไม่ผ่าน',
    'agency_rejected':'แพลตฟอร์มถูกปฏิเสธ',
    'select':'เลือก',
    'search':'ค้นหา',
    'rejection_reason':'เหตุผลในการปฏิเสธ',
    'no_data':'ข้อมูลว่างเปล่า',
    'oper_failed':'การดำเนินการล้มเหลว',
    'leave_agency_apply':'การอนุมัติให้ถอนกิลด์',
    'over_word_limit':'ตัวอักษรเกินจำนวนที่กำหนด',
    'delete':'ลบ',
    'nickname':'ชื่อเล่น',
    'file_is_too_large':'ไฟล์ใหญ่เกินไป',

    'community_convention':'การประชุมชุมชนบัซคาสต์',
    'approval_time':'เวลาอนุมัติ',
    'guild_system_title':'ระบบกิลด์แพลตฟอร์มโซเชียล BuzzCast',
    'return':'กลับไป',
    'img_upload_fail':'อัพโหลดรูปภาพไม่สำเร็จ',
    'cooper_ing':'ในความร่วมมือ',
    'upload_file_format_incorrect':'ไฟล์ที่อัพโหลดอยู่ในรูปแบบที่ไม่ถูกต้อง',
    'token_invalid':'โทเค็นไม่ถูกต้อง โปรดเข้าสู่ระบบอีกครั้ง!',
    'network_busy':'เครือข่ายไม่ว่างโปรดลองอีกครั้ง',
    'minute':'{msg_ss}นาที',

    'live_room_ID':'รหัสห้องถ่ายทอดสด',
    'scan_code':'สแกนรหัสเพื่อเข้าสู่ระบบBuzzCast APP',
    'open_code':'เปิด BuzzCastApp คลิกรหัส QR ของฉันเพื่อสแกน',
    'refresh':'รีเฟรช',
    'login_confirm':'ยืนยันการเข้าสู่ระบบ',
    'account':'ข้อมูลของบัญชี',
    'user_name':'ชื่อผู้ใช้',
    'edit':'แก้ไข',
    'changing':'เปลี่ยนการผูก',
    'mobile_number':'บัญชีมือถือ',
    'mobile_login':'คุณสามารถเข้าสู่ระบบด้วยหมายเลขโทรศัพท์ {msg_ss}',
    'appId_login':'คุณสามารถใช้บัญชี AppID [{msg_ss}] เพื่อสแกนและเข้าสู่ระบบ',
    'code_login':'ยังไม่มีBuzzCastAppIDถูกผูกไว้ หลังจากผูกมัด คุณสามารถสแกนรหัสQRเพื่อเข้าสู่ระบบ',
    'verification_log':'ยังไม่มีหมายเลขโทรศัพท์ถูกผูกไว้ หลังจากผูกมัด คุณสามารถเข้าสู่ระบบโดยหมายเลขโทรศัพท์และรหัสยืนยัน',
    'binding_success':'ผูกความสำเร็จ',
    'binding_mobile':'ผูกหมายเลขโทรศัพท์',
    'edit_name':'เปลี่ยนชื่อผู้ใช้',
    'binding_alert':'แจ้งเปลี่ยนการผูก',
    'new_appId':'หากใช้ APPID ใหม่สแกนรหัสการผูก APPID เดิมจะถูกแทนที่โดยตรง',
    'binding_account':'ผูกบัญชี BuzzCastApp',
    'anchor_earings':'รายได้ของสมอ',
    'signing_date':'วันที่เซ็นสัญญา',
    'statistical_date':'วันที่สถิติ',
    'valid_min':'เวลาที่มีผลทั้งหมด (นาที)',
    'valid_day':'วันที่มีผล（จำนวนวัน）',
    'total_revenue':'รายได้รวม',

    'bind':'ผูกกับ',
    'please_agree_agree':'โปรดยอมรับสัญญา',
    'note':'หมายเหตุ: เวลาที่แสดงโดยระบบนี้คือเวลานิวยอร์ก (EST)',
    'app_phone':'ลงทะเบียนหมายเลขโทรศัพท์มือถือของ APP',
    'host_num':'จำนวนโฮสต์',
    'enter_host_num':'กรุณาใส่หมายเลขของโฮสต์ทั้งหมด',
    'platform':'แพลตฟอร์มความร่วมมือ',
    'statement':'ใบแจ้งยอดธนาคารรายเดือน',
    'enter_income':'กรุณากรอกรายได้เฉลี่ยต่อเดือน',
    'check_commas':'รูปแบบไม่ถูกต้อง โปรดตรวจสอบว่ามีหลายแพลตฟอร์มคั่นด้วยเครื่องหมายจุลภาคหรือไม่',
    'submit_success':'ส่งเอกสารของคุณเรียบร้อยแล้ว! เราจะจัดการกับมันโดยเร็วที่สุด',
    'usd':'ดอลล่าร์',
    'many_platforms':'โปรดป้อนแพลตฟอร์มการถ่ายทอดสดที่คุณเคยร่วมมือมาก่อน มากถึง 20 แพลตฟอร์ม',
    'limit_platform': 'มากถึง 20 แพลตฟอร์ม',
    'user_has_delete':'ผู้ใช้ออกจากระบบ',
    'cant_commit':'คุณเป็นผู้ออกอากาศตามสัญญาแล้ว และคุณไม่สามารถสมัครกิลด์เพื่อตั้งรกรากพร้อมกันได้',
    'cant_commit_1':'คุณได้สมัครผู้ประกาศตามสัญญาแล้ว และคุณไม่สามารถสมัครกิลด์เพื่อตั้งรกรากพร้อมกันได้',
    'passwd': 'รหัสผ่าน',
    'passwd_placeholder': 'รองรับรหัสผ่าน6ถึง20อักษา',
    'live_rights': 'การประเมินแบบไร้เวลา',
    'edit_log': 'บันทึกการเปลี่ยนแปลง',
    'edit_time': 'เวลาปรับเปลี่ยน',
    'edit_pwd': 'เปลี่ยนรหัสผ่าน',
    'old_pwd': 'รหัสผ่านเก่า',
    'new_pwd': 'รหัสผ่านใหม่',
    'confirm_pwd': 'ยืนยันรหัสผ่าน',
    'forget_pwd': 'ลืมรหัสผ่าน?',
    'email_check': 'รูปแบบกล่องจดหมายไม่ถูกต้อง',
    'phone_pwd_error': 'หมายเลขโทรศัพท์หรือรหัสผ่านไม่ถูกต้อง',
    'ten_min_error': 'โปรดลองอีกครั้งใน 10 นาที',
    'phone_bind_error': 'หมายเลขโทรศัพท์มือถือถูกผูกไว้กับบัญชีอื่นโปรดเปลี่ยนหมายเลขโทรศัพท์มือถือใหม่เพื่อผูก',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'ID หัวหน้ากิลด์ถูกกรอกแล้ว กรุณากรอกอีกครั้ง',
    'pwd_error': 'รหัสผ่านผิด',
    'phone_not_reg_error': 'บัญชีไม่ได้ลงทะเบียน',
    'pwd_nq': 'รหัสผ่านใหม่ที่ป้อนสองครั้งไม่สอดคล้องกัน',
    'sign_anchor_error': 'คุณเป็นผู้ออกอากาศตามสัญญาแล้ว และคุณไม่สามารถสมัครกิลด์เพื่อตั้งรกรากพร้อมกันได้',
    'apply_anchor_error': 'คุณได้สมัครผู้ประกาศตามสัญญาแล้ว และคุณไม่สามารถสมัครกิลด์เพื่อตั้งรกรากพร้อมกันได้',
    'have-expired':'หมดอายุ',
    'approval-time':'เวลาอนุมัติ',
    'reasons-for-refusal':'โปรดป้อนเหตุผลสำหรับการปฏิเสธ',
    'Transfer-grounds':'เหตุผลในการโอน：',
    'code_expire': 'รหัสยืนยันหมดอายุแล้วกรุณาคลิกรหัสยืนยันเพื่อรีเฟรช',
    'transfer-approval':'การอนุมัติการโอน',
    'live_state_placeholder': 'สถานะการเริ่มต้น',
    'live_state_open': 'ปกติ',
    'live_state_temporary_banned': 'ห้ามออกอากาศ',
    'live_state_forever_banned': 'ห้ามออกอากาศอย่างถาวร',
    'live_allowed_time': 'เวลาเริ่มต้นที่อนุญาต',
    'live_banned_time': 'รอบห้ามออกอากาศ',
    'deduct_money': 'จำนวนเหรียญ B ที่หัก',
    'final_income': 'รายได้จริง',
    'select_start_dt': 'โปรดเลือกเวลาที่เริ่ม',
    'select_end_dt': 'โปรดเลือกเวลาสิ้นสุด',
    'less_then_end_dt': 'เวลาเริ่มต้นต้องน้อยกว่าเท่ากับเวลาสิ้นสุด',
    'System_automatically_through':'ระบบจะผ่านอัตโนมัติ',
    'btrade_err': 'ไม่สามารถใช้ ID กิลด์นี้ได้',

    'mouth_anchor': 'ผู้ประกาศข่าวรายเดือน',
    'day_anchor': 'ผู้ประกาศข่าวเงินเดือนรายวัน',
    'guild_anchor': 'รางวัลผู้นํากิลด์ (เงินเดือนรายวัน)',
    'mouth_anchor_st': 'เวลาเริ่มต้นเงินเดือนรายเดือน',
    'mouth_anchor_et': 'เวลาสิ้นสุดของเงินเดือนรายเดือน',
    'day_anchor_st': 'เวลาเริ่มต้นเงินเดือนรายวัน',
    'day_anchor_et': 'เวลาสิ้นสุดของเงินเดือนรายวัน',
    'all_award_bcoin': 'รายได้รวมของรางวัลเงินเดือนรายวัน',
    'live_hour': 'รางวัลระยะเวลาที่มีประสิทธิภาพสด',
    'salary_day': 'วันที่',
    'day_in_come': 'รายได้ของกิลด์ในวันเดียวกัน (เหรียญ B)',
    'award_ration_flag_str': 'สัดส่วนรางวัล',
    'payable_money': 'รางวัลเหรียญ B ผู้นํากิลด์',
    'host_bcoins': 'รายได้สมอเหรียญ B',
    'total_official': 'จํานวนรวมเหรียญรางวัลเหรียญ B อย่างเป็นทางการ',
    'actual_bcoins_awarded': 'รางวัลเหรียญ B จริง',
    "change_bound_account":"เปลี่ยนหมายเลขบัญชีที่ผูก" ,
    "agent_id_form":"ID หัวหน้ากิลด์:" ,
    "BuzzCast_verification_code":"รหัสยืนยัน BuzzCast:" ,
    "send_success":"ส่งสำเร็จแล้ว" ,
    "account_changed_successfully":"เปลี่ยนบัญชีที่มีผลผูกพันเรียบร้อยแล้ว" ,
    "invite_guild_url":"ได้รับเชิญให้เป็นประธานของ BuzzCast ลิงค์: {msg_ss}" ,
    "invite_guild_code":"รหัสเชิญของฉัน: {msg_ss}" ,
    "save":"เก็บ" ,
    "compile":"แก้ไข" ,
    "agent_nvitation_eward":"หัวหน้ากิลด์เชิญรางวัล" ,
    "agent_name":"ชื่อเล่นของหัวหน้ากิลด์" ,
    "guild_id":"รหัสกิลด์" ,
    "guild_income_30days":"รายได้ของกิลด์ในช่วง 30 วันที่ผ่านมา" ,
    "guild_invite_income_30days":"รายได้จากการเชิญกิลด์ในช่วง 30 วันที่ผ่านมา" ,
    "agency_commission_ratio":"อัตราค่าคอมมิชชั่นพันธมิตร" ,
    "invite_income_bcoins":"คำเชิญรับรางวัลเหรียญ B" ,
    "id_not_exist": "ไม่พบ ID นี้ในระบบ",
    'reward_distribution_status': 'สถานะการแจกรางวัล',
    'must_number': 'ข้อมูลที่คุณป้อนจะต้องอยู่ในรูปแบบตัวเลขล้วนๆ',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/th.js